import { fork } from 'redux-saga/effects';
import watchInitPage from './watchInitPage';
import watchAppLink from './watchAppLink';
import watchChargeSetupIntent from './watchChargeSetupIntent';

export default function* watchConfirmation() {
  yield fork(watchInitPage);
  yield fork(watchAppLink);
  yield fork(watchChargeSetupIntent);
}
